export const TeapotIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_16583_10411)">
          <path
            d="M10.29 3H13.71C14.2024 2.99997 14.6774 3.18155 15.0443 3.50999C15.4111 3.83842 15.6438 4.29062 15.698 4.78L17.253 18.78C17.2839 19.0595 17.2556 19.3424 17.1698 19.6102C17.084 19.878 16.9427 20.1247 16.7551 20.3342C16.5675 20.5437 16.3378 20.7113 16.081 20.826C15.8243 20.9407 15.5462 21 15.265 21H8.735C8.45378 21 8.17572 20.9407 7.91897 20.826C7.66222 20.7113 7.43254 20.5437 7.24494 20.3342C7.05734 20.1247 6.91603 19.878 6.83023 19.6102C6.74443 19.3424 6.71607 19.0595 6.747 18.78L8.302 4.78C8.35616 4.29062 8.58893 3.83842 8.95575 3.50999C9.32256 3.18155 9.79764 2.99997 10.29 3Z"
            stroke={fill}
            strokeWidth="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.46997 12.5L3.21297 7.48101C3.10162 7.34992 3.03021 7.18964 3.00722 7.01918C2.98422 6.84872 3.01061 6.67525 3.08325 6.51934C3.15589 6.36343 3.27173 6.23163 3.41702 6.13958C3.56232 6.04753 3.73097 5.99909 3.90297 6.00001H16.993C17.3875 5.99909 17.7784 6.07601 18.1432 6.22636C18.508 6.37671 18.8395 6.59755 19.1188 6.87621C19.3981 7.15488 19.6197 7.48591 19.7709 7.85034C19.9221 8.21478 20 8.60546 20 9.00001V12C20 13.657 18.654 15 16.993 15"
            stroke={fill}
            strokeWidth="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7 17H17"
            stroke={fill}
            strokeWidth="0.7"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_16583_10411">
            <rect width={width} height={height} fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};
